'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var modalTypes = {
    ABSENTEE_BID: 'ABSENTEE_BID',
    ADD_SEARCH_ALERT: 'ADD_SEARCH_ALERT',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    COMPLETE_ACCOUNT: 'COMPLETE_ACCOUNT',
    CONFIRM_CONSIGNMENT: 'CONFIRM_CONSIGNMENT',
    CONFIRM_PASSWORD: 'CONFIRM_PASSWORD',
    DOWNLOAD_MOBILE: 'DOWNLOAD_MOBILE',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
    HEALTHCHECK: 'HEALTHCHECK',
    INSTALL_FLASH: 'INSTALL_FLASH',
    ITEM_DESCRIPTION: 'ITEM_DESCRIPTION',
    LIVE_BID: 'LIVE_BID',
    LOGIN: 'LOGIN',
    NONE: 'NONE',
    REGISTER_FOR_AUCTION: 'REGISTER_FOR_AUCTION',
    RETRACT_BID: 'RETRACT_BID',
    SEND_SELLER_MESSAGE: 'SEND_SELLER_MESSAGE',
    SET_PASSWORD: 'SET_PASSWORD',
    SIGN_UP: 'SIGN_UP'
};

exports.default = modalTypes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/enums/modalTypes.js
// module id = GlFK
// module chunks = 46